import { faWarning } from "@fortawesome/free-solid-svg-icons";
import WarningMessage from "~/features/common/components/WarningMessage/WarningMessage";
import Icon from "~/features/common/components/icons/Icon/index";
import { useRequiredClientVersionQuery } from "~/generated/graphql";
import { version } from "../../../../../../appVersion.json";

const ClientVersionCheck = ({ collapsed }: { collapsed: boolean }) => {
  const versionQuery = useRequiredClientVersionQuery();
  const requiredClientVersion = versionQuery.data?.requiredClientVersion;
  if (versionQuery.isLoading) {
    return null;
  }

  if (!requiredClientVersion) {
    return null;
  }

  const warningMessageText = `Client Version Mismatch! <br />
<strong>Required: ${requiredClientVersion} </strong><br />
Current: ${version}`;
  if (requiredClientVersion !== version) {
    return !collapsed ? (
      <WarningMessage classNames="my-2 mx-1" level="yellow" textSize="text-xs">
        <span>
          Client Version Mismatch! <br />
          <strong>Required: {requiredClientVersion} </strong>
          <br />
          Current: {version}
          <br />
          <a
            href="https://paceteq-s3-customerdownloads.s3.eu-central-1.amazonaws.com/oneracehub-latest.exe"
            target="_blank"
            rel="noopener noreferrer">
            Download Latest
          </a>
        </span>
      </WarningMessage>
    ) : (
      <span className="my-3 flex justify-center text-amber-500">
        <Icon html={warningMessageText} icon={faWarning} />
      </span>
    );
  }
  return null;
};

export default ClientVersionCheck;
